import React from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/AddCircle';

import "../../../styles/css/search.css";

export default function DetailHandler({listHandler, details}) {
  const [text, setText] = React.useState("");
  // const [list, setList] = React.useState([]);

  const handleChange = (event) => {
    setText(event.target.value);
  };

  const addHandler = () => {
    let tempList = [];

    if (text !== "") {
      tempList = [...details, text]
      // setList(tempList);
      setText("");
      listHandler(tempList)
    }
  }

  const deleteHandler = index => {
    let tempList = details.filter((t, i) => i !== index)
    // setList(tempList);
    listHandler(tempList)
  }
  
  return (
    <div>
      <div className={"list-manager"}>
        {details && details.length > 0 ?
          details.map((t, i) => {
            return(
              <div className={"list-item"}>
                <p>{t}</p>
                <DeleteIcon onClick={()=> {
                  deleteHandler(i)
                }}/>
              </div>
            );
          }):("")
        }
      </div>
      <div className={"textarea-container"}>
        <textarea value={text} onChange={handleChange}></textarea>
        <AddIcon onClick={addHandler} />
      </div>
    </div>
  );
}
